import React from "react";

import LoginForm from "../../../components/Auth/Login/LoginForm";

const Login = ({ history }) => <LoginForm history={history} ></LoginForm>;

export default Login;